<template>
  <div id="item-detail-page" v-if="loaded" class="rounded relative overflow-hidden body-module-height z-20">
    <vs-alert color="danger" title="Error Fetching Product Data" :active.sync="error_occured">
      <span>{{ error_msg }}. </span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'ecommerce-shop'}" class="text-inherit underline">All Items</router-link>
      </span>
    </vs-alert>

    <bds-scroll-area component-class="content-scroll-area specific-height">
      <vx-card :cardBorder="true">
        <template slot="no-body">

          <!-- HEADER -->
          <div class="w-full flex flex-row">
            <vs-button type="border" color="primary" icon-pack="feather" icon="icon-arrow-left-circle" size="small"
                       @click="$router.go(-1)"
                       class="flex justify-center text-xs">
              {{ $t('buttons.back') }}
            </vs-button>

            <div class="w-full flex justify-center">
              <span class="text-lg font-bold text-secondary">{{ $t('pages.shop.detailItem.resume') }}</span>
            </div>
          </div>

          <div class="vx-row my-3 flex">
            <div class="vx-col w-full sm:w-1/2 md:w-1/4 flex items-center justify-end">
              <div class="mx-auto bg-gray-400">
                <img :src="product.image" :alt="productLang.name" class="w-36">
              </div>
            </div>

            <div class="vx-col w-full md:w-1/2 flex-wrap text-left my-1">
              <div class="vx-row w-full flex">
                <div class="vx-col w-full md:w-2/3 border-solid border-r-2 border-primary">
                  <div class="text-sm"> {{ $t('pages.products.lang.name') }} </div>
                  <div class="text-lg text-left"> {{ product.code }} - {{ productLang.name }} </div>
                </div>

                <div class="vx-col w-full md:w-1/3 flex flex-col">
                  <div class="flex justify-between mb-2">
                    <p class="item-description text-sm mx-2"> {{ $t('pages.shop.price') }} </p>
                    <h5 class="font-bold text-center" v-if="$store.state.Profile.isBRL()">{{ this.product.price | BRL }}</h5>
                    <h5 class="font-bold text-center" v-else>{{ this.product.price | USD }}</h5>
                  </div>

                  <template v-if="product.isCombo()">
                    <div class="flex justify-between mb-2" v-if="product.discount > 0">
                      <p class="item-description text-sm mx-2"> {{ $t('pages.shop.discount') }} </p>
                      <h5 class="font-bold text-center" v-if="$store.state.Profile.isBRL()">({{ product.discount }}%) {{ this.calcDiscount | BRL }}</h5>
                      <h5 class="font-bold text-center" v-else>({{ product.discount }}%) {{ this.calcDiscount | USD }}</h5>
                    </div>

                    <vs-divider v-if="product.discount > 0"/>

                    <div class="flex justify-between mb-2" v-if="product.discount > 0">
                      <p class="item-description text-sm mx-2"> {{ $t('pages.shop.total') }} </p>
                      <h5 class="font-bold text-center" v-if="$store.state.Profile.isBRL()">{{ this.calcTotal | BRL }}</h5>
                      <h5 class="font-bold text-center" v-else>{{ this.calcTotal | USD }}</h5>
                    </div>
                  </template>
                </div>
              </div>

              <div class="w-full border-solid border-t-2 border-primary my-4 p-2">
                <div class="text-sm mb-2">
                  {{ $t('pages.products.lang.description') }}
                </div>

                <div class="text-sm text-black flex text-justify">
                  {{ productLang.description | readMore(190, '...') }}
                </div>
              </div>
            </div>

            <div class="vx-col w-full sm:w-1/2 lg:w-1/4 flex items-center justify-center">
              <vs-button
                icon-pack="feather"
                icon="icon-shopping-cart"
                v-if="!isInCart(product.id)"
                @click="toggleItemInCart(product.id)">
                {{ $t('pages.shop.addToCart') | uppercase }}
              </vs-button>

              <vs-button
                v-else
                icon-pack="feather"
                icon="icon-shopping-cart"
                @click="viewInCart">
                {{ $t('pages.shop.viewInCart') | uppercase }}
              </vs-button>
            </div>
          </div>
        </template>
      </vx-card>

      <!-- TODO ajustar scroll -->
      <ECommerceDetailViewItem v-for="id in innerProducts" :product-id="Number(id)" :key="Number(id)"/>
    </bds-scroll-area>
  </div>
</template>

<script>

import ECommerceDetailViewItem from "./ECommerceDetailViewItem";
import ShopService from "@/services/Shop.service";
import {showErrorNotify} from "@/helpers/functionsHelpers";
import ProductCategoryService from "@/services/ProductCategory.service";

export default {
  components: {
    ECommerceDetailViewItem
  },
  data () {
    return {
      error_occured: false,
      error_msg: '',

      productId: 0,

      loaded: false,
    }
  },
  computed: {
    productLang() {
      const locale = this.$i18n.locale;
      return this.product[locale];
    },
    product() {
      return this.$store.getters['Shop/getProductByIdFromShop'](this.productId);
    },
    calcDiscount() {
      return this.product.getDiscount();
    },
    calcTotal() {
      return this.product.getPrice() - this.calcDiscount;
    },
    innerProducts() {
      return this.product.getInnerProductsId();
    },
    isInCart() {
      return (itemId) => this.$store.getters['Shop/isInCart'](itemId);
    },
  },
  methods: {
    toggleItemInCart (item_id) {
      this.$store.dispatch('Shop/toggleItemInCart', item_id);
    },
    viewInCart() {
      this.$nextTick(() => {
        this.$router.push({name: 'shop-checkout'});
      });
    }
  },
  created () {
    this.loaded = false;
    this.productId = Number(this.$route.params.item_id);
    const p = this.$store.getters['Shop/getProductByIdFromShop'](this.productId);
    if (!p) {
      const promiseProducts = ShopService.getProductsFromShop().then((response) => {
        this.$store.dispatch('Shop/setProductsFromShop', response);
        return Promise.resolve(true);
      }, (error) => {
        showErrorNotify(this, error);
        return Promise.reject(error);
      });

      const promiseCategories = ProductCategoryService.getProductCategories().then((response) => {
        this.$store.dispatch('ProductCategory/setCategories', response);
        return Promise.resolve(true);
      }, (error) => {
        showErrorNotify(this, error);
        return Promise.reject(error);
      });

      Promise.all([promiseProducts, promiseCategories]).then((results) => {
        console.debug('Pagina produtos carregada => ', results);
        this.$nextTick(() => {
          this.loaded = true;
        });
      });
    } else {
      this.loaded = true;
    }
  },
  mounted() {
    console.log('MOUNTING...');
  }
}
</script>

<style lang="scss">
#item-detail-page {
  .content-scroll-area.specific-height {
    height: calc(100%);
  }

  @media screen and (min-width: $screen-md-min) {
    .content-scroll-area.specific-height {
      height: calc(100%);
    }
  }

  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .related-product-swiper {
      // padding-right: 2rem;
      // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0,0,0,0.1), 0 5px 12px 0 rgba(0,0,0,0.08) !important;

        .theme-dark & {
          background-color: $theme-light-dark-bg;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
</style>
